<template>
    <div >
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">Highlights</li>
		</ol>

        <h1 class="page-header">Highlights</h1>
        <hr>

        <!-- Tabs Start -->
        <div class="mb-4">
          <ul class="nav nav-tabs" style="display: flex; justify-content: space-evenly;">
            <li class="nav-item" v-for="(tabName, index) in tabs">
              <a
                class="nav-link"
                :class="{
                  'active' : tab == index,
                  'clickAble' : tab != index
                }"
                @click="tab = index"
              >{{ tabName }}</a>
            </li>
          </ul>
        </div>
        <!-- Tabs End -->

        <!-- Tab Body 
            V-if to determine if the page is ever loaded
            v-show to show currently selected Tab

            to add a page, please add tabs array with the corresponding name tab 
            and add activeTab with false

            and then add the component below with the name of component and 
            tabs.indexOf('${NAME_OF_TAB}')

            - Marvin
        -->

        <H1
            v-if="activeTab[parseInt(tabs.indexOf('PDC'))]"
            v-show="tab == parseInt(tabs.indexOf('PDC'))"
        />

        <!-- <H2
            v-if="activeTab[parseInt(tabs.indexOf('Dealer'))]"
            v-show="tab == parseInt(tabs.indexOf('Dealer'))"
        /> -->
        

    </div> 
</template>

<script>
import H1 from './childComponents/H1'
import H2 from './childComponents/H2'

export default {
    components : {
        H1,
        H2
    },
    data () {
        return {
            tabs : ['PDC'],
            tab : 0,
            activeTab : [true , false]
        }
    },
    watch : {
        tab : function () {
            this.activeTab[this.tab] = true
        }
    }
}
</script>


<style scoped>
  .nav-tabs, .nav-link{
    border:1px solid transparent !important;
  }
  .nav-tabs {
    border-bottom: 1px solid #dee2e6 !important;
  }
  .nav-link{
    border:1px solid !important;
    border-color: #dee2e6 #dee2e6 #fff #dee2e6 !important;
  }
  .nav-link.active{
    border-color:#dee2e5 #dee2e6 #fff !important;
    background-color:#F5F5F5;
  }

  .nav-item {
    width:50%;
    text-align: center;
  }
  .clickAble:hover{
    cursor:pointer;
  }
</style>
